import {Text} from "@web-libs/ui/ui-components/typo/text";
import {getCssVar} from "@web-libs/features/colors/application/colors";
import {LanguageSelector} from "@web-libs/ui/ui-components/language-selector/language-selector";

export type MobileMenuItem = {
    name: string
    indicator?: boolean
    active?: boolean
    onClick?: () => void,
    secondary?: boolean
}

export const MobileMenuItems = ({items, close}: { items: MobileMenuItem[], close: () => void }) => {

    const _styles = {
        marginBottom: 32,
        display: "flex",
        alignItems: "center"
    }

    const primaryItems = items.filter(item => !item.secondary);
    const secondaryItems = items.filter(item => item.secondary);

    const handleClick = (item: MobileMenuItem) => {
        item.onClick?.();
        close();
    }

    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            {
                primaryItems.map(
                    item => {
                        return (
                            <div key={item.name} style={{..._styles, ...(item.active ? {color: getCssVar("primary")} : {})} } onClick={() => handleClick(item)}>
                                { item.indicator && <div
                                    style={{marginRight: 12,width: 12, height: 12, backgroundColor: getCssVar("warn"), borderRadius: 8}}></div>}
                                <Text bold size={"lg"} block>
                                    {item.name}
                                </Text>

                            </div>
                        )
                    }
                )
            }
            <LanguageSelector style={{marginBottom: 8}}/>
            {
                secondaryItems.map(
                    item => {
                        return <div key={item.name} style={{..._styles, fontSize: 12, marginBottom: 8, marginTop: 8, ...(item.active ? {color: getCssVar("primary")} : {})} } onClick={() => handleClick(item)}>{item.name}</div>
                    }
                )
            }
        </div>
    )
}
